<template>
  <div class="animated fadeIn">
    <b-card v-if="show">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Detect / Block Log
      </template>
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="5">
            From
            <b-form >
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="5">
            To
            <b-form >
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" type="datetime" :format="'YYYY MM DD hh:mm A'" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>METHOD</span> </b-form> </b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="GET" value="GET" v-model="so.opt.method" @click="so.sk='request'"> <label for="GET">GET</label></b-form></b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="POST" value="POST" v-model="so.opt.method" @click="so.sk='request'"> <label for="POST">POST</label> </b-form> </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Response</span> </b-form> </b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="DetectionOnly" :value="false" v-model="so.opt.is_block" @click="so.sk='is_block'"> <label for="DetectionOnly"><b-badge variant="warning">DetectionOnly</b-badge></label></b-form></b-col>
          <b-col md="2"> <b-form class="m-2"> <input type="radio" id="Block" :value="true" v-model="so.opt.is_block" @click="so.sk='is_block'"> <label for="Block"><b-badge variant="danger">Block</b-badge></label> </b-form> </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Attacker</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_remote_addr" v-model="so.opt.remote_addr" :placeholder="'typing attacker'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <!-- <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>국가코드</span> </b-form> </b-col>
          <b-col md="1">
            <country-flag v-if="so.opt && so.opt.country_code!='-' && so.opt.country_code.value" :country="so.opt.country_code.value || so.opt.country_code" size='normal'/>
          </b-col>
          <b-col md="8">
            <b-form>
              <v-select v-model="so.opt.country_code" :options="country_list" :placeholder="'국가를 선택하세요'"></v-select>
            </b-form>
          </b-col>
        </b-row>
        <hr> -->
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Victim</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_target" v-model="so.opt.target" :placeholder="'typing Victim'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>Detect message</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_message" v-model="so.opt.message" :placeholder="'typing detect message'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3"> <b-form class="m-2"> <span>URI</span> </b-form> </b-col>
          <b-col md="9">
            <b-form>
              <b-form-input type="text" id="ph_uri" v-model="so.opt.uri" :placeholder="'typing URI'"></b-form-input>
            </b-form>
          </b-col>
        </b-row>
        <hr>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh">Search</b-button>
          <b-button size="sm" variant="secondary" @click="reset">Reset</b-button>
          <b-button size="sm" variant="dark" @click="so.sv=so.sk=''; so.adv = false; reset">Exit</b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col sm="12">
          <span class="text-center" v-b-tooltip.hover title="can see the log real-time" v-if="auto_refresh != false">
            Real-time Refresh interval
            <select v-model="sync.interval" @change="refresh">
              <option value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            sec
          </span>
          <span class="float-right">
            <i :class="`fa fa-refresh ${th && !sync.stop ? 'fa-spin' : ''}`"></i>
            <b-btn v-if="this.sync.stop" @click="pause" size="sm" variant="warning">Pause</b-btn>
            <b-btn v-if="!this.sync.stop" @click="pause" size="sm" variant="warning">Stop</b-btn>
          </span>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col :sm="options && options.length ? 3 : 6">
          Show count
          <select v-model="so.perPage" @change="refresh">
            <option value="10">Show count : Default 10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </b-col>
        <b-col sm="4">
           <b-form-group v-if="options && options.length" label="Select custom showing data">
            <b-form-checkbox-group
              v-model="selected"
              :options="options"
              button-variant="primary"
              name="option"
              buttons
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <b-col sm="5" v-if="only_view != true">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='remote_addr';so.skt=`Attacker`">Attacker</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='target';so.skt=`Target`">Victim</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='message';so.skt='Rule'">Rule</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='uri';so.skt='URI'">URI</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = true;"><i class="fa fa-search-plus"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_wc_log_list"
        show-empty empty-text="not found"
        :items="getItems"
        :fields="fields"
        :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row"> {{startRow - row.index}}</template>
        <template slot="host" slot-scope="row">{{row.item.host}}</template>
        <template slot="castle" slot-scope="row">{{row.item.castle && row.item.castle.nickname ? row.item.castle.nickname : '-'}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | utcdatetime}}</template>
        <template slot="remote_addr" slot-scope="row">{{row.item.remote_addr}}</template>
        <template slot="target" slot-scope="row">{{row.item.target}}</template>
        <template slot="protocol" slot-scope="row">{{row.item.protocol}} {{row.item.method}}</template>
        <template slot="is_block" slot-scope="row">
          <b-badge v-if="row.item.is_block" variant="danger">Block</b-badge>
          <b-badge v-else variant="warning">DetectionOnly</b-badge>
        </template>
        <template slot="message" slot-scope="row">
          {{row.item.message ? row.item.message.message : `[Need To Agent upgrade] ${row.item.m_file}(Line:${row.item.m_line})`}}
          <!-- {{row.item.message && row.item.message.messages.length > 0 ? row.item.messages : '' }} -->
        </template>
        <template slot="severity" slot-scope="row">
          <span v-if="row.item.message" class="font-weight-bold">
            <span scope="row" v-if="row.item.message.details.severity == 1"><b-badge variant="primary">Alert</b-badge></span>
            <span scope="row" v-else-if="row.item.message.details.severity == 2"><b-badge variant="info">Notice</b-badge></span>
            <span scope="row" v-else-if="row.item.message.details.severity == 3"><b-badge variant="light">Warning</b-badge></span>
            <span scope="row" v-else-if="row.item.message.details.severity == 4"><b-badge variant="warning">Error</b-badge></span>
            <span scope="row" v-else-if="row.item.message.details.severity == 5"><b-badge variant="danger">Critical</b-badge></span>
            <span scope="row" v-else-if="row.item.message.details.severity > 5"><b-badge variant="danger">Emergency</b-badge></span>
            <span scope="row" v-else>Not recognized</span>
          </span>
          <span v-else>
            <span scope="row">
              <b-button size="sm" :id="'tooltip_not_defined'+row.index" variant="outline-dark">
                Not Defined
              </b-button>
              <b-tooltip :target="'tooltip_not_defined'+row.index" triggers="hover">
                It could be a new attack, or it could not have been dispersed.
              </b-tooltip>
            </span>
          </span>
        </template>

        <template slot="uri" slot-scope="row">{{autoSize() < row.item.uri.length ? row.item.uri.substring(0, autoSize()) + "..." : row.item.uri.substring(0, autoSize())}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
          <!-- <b-btn @click="$router.push({  })" size="sm" variant="success">Rule</b-btn> -->
        </template>
      </b-table>
      <hr>
      <b-row v-if="only_view != true">
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/>
        </b-col>
      </b-row>
    </b-card>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import { api, auth } from '@/f1/service';
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/f1/custom';
import _ from 'lodash'

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
});

export default {
  props : ['only_view', 'auto_refresh', 'agent_id_list'],
  data: () => {
    return {
      extra : false,
      th : undefined,
      custom,
      show: true,
      auth : auth,
      so : default_opt(),
      sync : { interval : 15, stop : false },
      selected : [],
      options: [],
      fields_data : [
        { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%', option : -2 },
        { key: 'created_at', label: 'DateTime', sortable: true, thStyle: 'width: 8%', option : 0 },
        { key: 'remote_addr', label: 'Attacker( => )', sortable: true, option : 0 },
        { key: 'agent.nickname', label: 'Nickname', sortable: true, thStyle: 'width: 5%', option : 1 },
        { key: 'target', label: 'Victim', sortable: true, option : 0 },
        { key: 'host', label: 'Host', sortable: true, thStyle: 'width: 5%', option : 0 },
        { key: 'is_block', label: 'Response', sortable: false, option : 0 },
        { key: 'message', label: 'Message', sortable: false, option : 0 },
        { key: 'severity', label: 'Risk', sortable: false, option : 0 },
        { key: 'protocol', label: 'Protocol', sortable: false, option : 2 },
        { key: 'uri', label: 'URI', sortable: false, option : 3 },
        { key: 'func', label: 'More', sortable: false, thStyle: 'width: 5%', option : -2  },
      ]
    }
  },
  components: {
    DatePicker
  },
  computed: {
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    fields() {
      return _.map(this.fields_data, f => {
        if(f.option < -1) {
          if(this.only_view != true) { return f }
        }
        else if(_.indexOf(this.selected, f.option) > -1 || f.option < 1) {
          return f
        }
      })
    }
  },
  methods: {
    autoSize : function() { return Number(window.innerWidth / 100) * 2 },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      if(!this.sync.stop) {
        this.$refs && this.$refs._wc_log_list ? this.$refs._wc_log_list.refresh() : ''
        console.log('refresh list')
      }
      clearTimeout(this.th)
      this.th = undefined
      this.th = setTimeout(this.refresh, 1000 * this.sync.interval)
    },
    getRowCount () { return this.so.totalRows || 0; },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        // od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        target : 'log', cmd : 'list'
      }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, target : so.target, cmd : so.cmd, body: { and: [{name : 'is_del', value:false, op: '='}], or: [], sort: [{name : 'id', op : 'desc'}] } }
      console.log(this.agent_id_list)
      if(this.agent_id_list) {
        for (let i = 0; i < this.agent_id_list.length; i++) {
          if(typeof this.agent_id_list[i] == 'object') {
            search.body.and.push({name : 'agent_id', value : this.agent_id_list[i].id, op : '='})
          } else {
            search.body.and.push({name : 'agent_id', value : this.agent_id_list[i], op : '='})
          }
        }
      }
      if(ctx.sortBy) { search.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      // search
      if(so.sk && so.sv) {
        const value = so.sv
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: `%${value}%`, op: 'like' });
        }

      }
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'uri' : search.body.and.push({name : 'uri', value : `%${value}%`, op : 'like'}); break;
          case 'message' : search.body.and.push({name : 'message', value : `%${value}%`, op : 'like'}); break;
          case 'target' : search.body.and.push({name : 'target', value : `%${value}%`, op : 'like'}); break;
          case 'remote_addr' : search.body.and.push({name : 'remote_addr', value : `%${value}%`, op : 'like'}); break;
          case 'method' : search.body.and.push({name : 'method', value : value, op : '='}); break;
          case 'is_block' : search.body.and.push({name : 'is_block', value : value, op : '='}); break;
          case 'backup_mode' : search.body.and.push({name: 'setting', value : `%backup_mode : ${value}%`, op : 'like'}); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'last_visit_sd' : search.body.and.push({name: 'last_visit', value: moment(value).valueOf(), op: '>=' }); break;
          case 'last_visit_ed' : search.body.and.push({name: 'last_visit', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: value, op: '=' }); break;
        }
      }
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
      return api.webcastle.WebCastle(search).then(rs => {
        this.so.totalRows = rs.total;

        if(rs.body && rs.body.length > 0){
          this.options = []
          this.fields_data.forEach(r => {
            if(r.option < 1) { return }
            this.options.push({ text: r.label, value: r.option })
          });

          return _.map(rs.body, r => {
            try { r.message = JSON.parse(r.message) } catch (e) { console.log("json parser failed"); r.failed = true; }
            r.message = _.maxBy(r.message.messages, function(x) { return Number(x.details.severity) })
            return r
          })
        }
        return rs.body;
      }).catch(e => {
        console.log(e)
        this.$toastr.e(e.data ? e.data.message : e.statusText)
      });
    },
    pause: function() { this.sync.stop = !this.sync.stop; this.refresh(); },
    detail: function(item) { console.log(item); this.$router.push(`log/${item.id}`); },
  	hideList: function(e) {
      this.show = !e; console.log('webcastle', 'log.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created: function() {   console.log('webcastle', 'log.vue', 'created'); },
  destroyed: function() { console.log('webcastle', 'log.vue', 'destroyed'); clearTimeout(this.th); this.th = undefined},
  mounted: function() { console.log('webcastle', 'log.vue', 'mounted'); },
}
</script>
